import { reactEvents } from '../../../bridge/reactEvents';

// @ngInject
const supplierResolve = ($stateParams, SuppliersApiService) =>
  SuppliersApiService.getById($stateParams.supplierId);

// @ngInject
const scrollTop = ($window) => $window.scrollTo(0, 0);

// @ngInject
const rootFolderIdResolve = (supplier) => supplier.folderId;

// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('supplier', {
    parent: 'main',
    url: '/suppliers/{supplierId}',
    views: {
      'main-content': {
        controller: 'SupplierController as vm',
        templateUrl: 'main/supplier/supplier.tpl.html',
      },
    },
    data: { pageTitle: 'Supplier' },
    resolve: { supplier: supplierResolve },
    onEnter: scrollTop,
  });

  // Files tab
  $stateProvider.state('supplier.files', {
    url: '/files',
    abstract: true,
    templateUrl: 'tabs/filesTab/filesTab.tpl.html',
    controller: 'FilesTabsController as vm',
    resolve: {
      rootFolderId: rootFolderIdResolve,
      isArticle: () => false,
      article: () => null,
      concept: () => null,
      customer: () => null,
    },
  });

  $stateProvider.state('supplier.files.id', {
    url: '/{folderPath:nonURIEncoded}',
    params: {
      folderPath: {
        value: null,
        squash: true,
      },
    },
  });
};

class SupplierController {
  constructor($scope, $state, supplier) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.supplier = supplier;
    reactEvents.entityVisited.dispatch({
      id: supplier.id,
      type: 'supplier',
      label: supplier.name,
    });
    this.supplierArchived = reactEvents.supplierArchived.subscribe(
      (supplierId) => {
        if (supplierId === this.supplier.id) {
          this.supplier.archived = true;
          this.$scope.$applyAsync();
        }
      },
    );

    this.supplierRestored = reactEvents.supplierRestored.subscribe(
      (supplierId) => {
        if (supplierId === this.supplier.id) {
          this.supplier.archived = false;
          this.$scope.$applyAsync();
        }
      },
    );

    this.supplierNameChanged = reactEvents.supplierNameChanged.subscribe(
      (supplier) => {
        if (supplier.id === this.supplier.id) {
          this.supplier.name = supplier.value;
          this.$scope.$applyAsync();
        }
      },
    );

    $scope.$on('$stateChangeSuccess', () => {
      if (this.$state.is('supplier')) {
        this.goToDefaultState();
      }
    });

    this.$scope.$on('$destroy', () => {
      this.supplierArchived();
      this.supplierRestored();
      this.supplierNameChanged();
    });
  }

  goToDefaultState() {
    this.$scope.$applyAsync(() => {
      this.$state.go('supplier.management', {}, { location: 'replace' });
    });
  }
}

angular
  .module('main.supplier', [
    'main.supplier.management',
    'main.supplier.contacts',
    'main.supplier.articles',
    'main.supplier.productGroups',
    'main.supplier.complianceDocuments',
  ])
  .config(config)
  .controller('SupplierController', SupplierController);
